import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import Modal from 'react-overlays/lib/Modal';

import { translate } from 'react-i18next';

const modalStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0, bottom: 0, left: 0, right: 0
};

const backdropStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0, bottom: 0, left: 0, right: 0,
  zIndex: 'auto',
  backgroundColor: '#000',
  opacity: 0.5
};

const dialogStyle = function() {
  // we use some psuedo random coords so nested modals
  // don't sit right on top of each other.

  return {
    position: 'absolute',
    width: 400,
    top: top + '%', left: left + '%',
    transform: `translate(-50%, -50%)`,
    border: '1px solid #e5e5e5',
    backgroundColor: 'white',
    boxShadow: '0 5px 15px rgba(0,0,0,.5)',
    padding: 20
  };
};


var SquallMduModal = React.createClass({


  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },


  continuePrequal(){
    AvailabilityActions.closeSquallMduModal(this.state.store.toJS());
  },

  updateSecondary(event) {
      if(event.type == 'click') {
        return;
      }
      AvailabilityActions.updateSecondary(event.target.value);
  },

	render() {
      const { t } = this.props;

      var store = this.state.store;

      if(Object.keys(store.get('lastPrequal').toJS()).length == 0) {
        return false;
      }

      var key = store.getIn(['lastPrequal', 'response', 'reason']);
    return (
      <div>
        <Modal
          aria-labelledby='modal-label'
          style={modalStyle}
          backdropStyle={backdropStyle}
          show={store.get('showSquallMduModal')}
          onHide={this.close}
        >
        <div className="modal show" tabIndex="-1" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">{t('common:'+key+'_title')}</h4>
              </div>
              <div className="modal-body">
                <p>{t('common:'+key+'_p')}</p>


                <div className="form-group">      
                  <label htmlFor="secondary">{t('common:secondary_label')} </label>
                  <input type="text" name="secondary" value={store.getIn(['input_address', 'secondary'])} onInput={this.updateSecondary} className="form-control" id="secondary" placeholder={t('common:mduwarn_secondary_placeholder')} />
                </div>

              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-default btn-block" onClick={this.continuePrequal}>{t('common:continue')}</button>
              </div>
            </div>
          </div>
        </div>
        </Modal>
      </div>
    );
  }
});

export default  translate('common', { wait: true })(SquallMduModal);